import { render, staticRenderFns } from "./PublishPage.vue?vue&type=template&id=4c8a9b8e&scoped=true"
import script from "./PublishPage.vue?vue&type=script&lang=js"
export * from "./PublishPage.vue?vue&type=script&lang=js"
import style0 from "./PublishPage.vue?vue&type=style&index=0&id=4c8a9b8e&prod&lang=scss&scoped=true"
import style1 from "./PublishPage.vue?vue&type=style&index=1&id=4c8a9b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8a9b8e",
  null
  
)

export default component.exports